<template>
    <div v-if="theme" class="rrlb-calendar transition-all overflow-hidden" :class="[classRoundness, {
        'border': !theme.borderless,
        'border-neutral-700' :theme.darkMode
    }]" :style="{
        '--vc-rounded-full': calendarRoundness
    }">
        <DatePicker :attributes="attributes" :isDark="theme.darkMode" :color="theme.color"
                    :rows="theme.rows" :borderless="true" is-required :locale="locale" expanded
                    :transparent="theme.borderless" :columns="multiselect ? 2 : 1" :is-range="multiselect"
                    :min-date="dateTimeRestrictions.min" :max-date="dateTimeRestrictions.max"
                    :disabled-dates="dateTimeRestrictions.disabled" mode="date" v-model="selectedDate"
                    :view="settings.view" :first-day-of-week="settings.firstDayOfWeek"
                    :title-position="settings.titlePosition" :transition="settings.transition"
                    :show-weeknumbers="settings.showWeekNumbers"
        >
        </DatePicker>
    </div>

    <div v-if="!neoDesign" class="flex justify-center">
        <div class="px-3 py-2 mt-3 flex flex-col gap-1 border-neutral-100 bg-neutral-300/15 text-xs opacity-80 relative" :class="[classRoundness, {
        'border': !theme.borderless,
        'border-neutral-700' :theme.darkMode
    }]">
            <div class="flex gap-2 items-center">
                <div class="w-5 h-5 flex justify-center items-center opacity-40 line-through">{{today}}</div>
                <p> nedostupné</p>
            </div>
            <div v-if="showPartialAvailability" class="flex gap-2 items-center">
                <div class="w-5 h-5 border-2 flex justify-center items-center" :class="`border-${theme.color}-500`" :style="{ borderRadius: calendarRoundness }">{{today}}</div>
                <p> dostupné</p>
            </div>
            <div class="flex gap-2 items-center">
                <div class="w-5 h-5 flex justify-center items-center">{{today}}</div>
                <p> volný termín</p>
            </div>
        </div>
    </div>
</template>
<script setup>
import {DatePicker} from 'v-calendar';
import InlineMessage from 'primevue/inlinemessage';
import RadioButton from 'primevue/radiobutton';
import {defineProps, computed, watch, ref, shallowRef} from 'vue';
import { DateTime } from 'luxon';
import 'v-calendar/style.css';
const props = defineProps({
    settings: Object,
    dateTimeRestrictions: Object,
    theme: Object,
    multiselect: Boolean,
    locale: String,
    calendarDates: Array,
    neoDesign: Boolean,
    showPartialAvailability: {
        type: Boolean,
        default: true,
    },
});
const today = new Date().getDate();

const classRoundness = computed(() => {
    switch (props.theme.roundness) {
        case 0:
            return 'rounded-0';
        case 1:
            return 'rounded-xl';
            case 2:
                return 'rounded-2xl';
                case 3:
                    return 'rounded-3xl';
                    default:
                        return 'rounded-full';
    }
})

const calendarRoundness = computed(() => {
    switch (props.theme.roundness) {
        case 0:
            return '0px';
        case 1:
            return '5px';
        case 2:
            return '10px';
        case 3:
        default:
            return '999px';
    }
})

const selectedDate = defineModel();

const localCalendarDates = shallowRef([]);

watch(() => props.calendarDates, (val) => {
    localCalendarDates.value = Array.isArray(val) ? [...val] : [];
}, { immediate: true, deep: true });

const todayAttribute = {
    key: 'today',
    dates: new Date(),
    order: 0,
    content: { style: { fontWeight: 'bold' } }
};

const attributes = computed(() => {
    if (localCalendarDates.value.length) {
        return [todayAttribute, ...localCalendarDates.value];
    }
    return [todayAttribute];
});


</script>
<style lang="scss" scoped>
.rrlb-calendar {
    display: flex;
    gap: 24px;
    flex-direction: row;

    .rrlbc-timeslots {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .rrlbct-timeslot {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 6px;

            .rrlbctt-time {
                font-weight: bold;
                color: var(--primary-color);

                &.disabled {
                    opacity: 0.5;
                }
            }

            .rrlbctt-disabled {
                color: rgb(184, 50, 50);
            }
        }
    }
}
</style>
